// 调用所有运行时插件，将入口文件 App 进行包裹
export default (function (plugins, WrappedApp, AppConfig, opts) {
    var getInitialProps = WrappedApp.getInitialProps;
    if (plugins && plugins.length > 0) {
        plugins.forEach(function (plugin) {
            if (typeof plugin === 'function') {
                // @ts-ignore set wrapped app as IApp
                WrappedApp = plugin(WrappedApp, opts === null || opts === void 0 ? void 0 : opts.router);
                WrappedApp.config = AppConfig;
                WrappedApp.getInitialProps = getInitialProps;
            }
        });
    }
    return WrappedApp;
});
//# sourceMappingURL=composeRuntimePlugins.js.map